import { useQuery } from '@tanstack/react-query';

import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { withParams } from '@telialt/utils/src/helpers';
import { useSiteName } from '@telialt/utils/src/segment';

import { API, QUERY_KEYS } from '../constants';
import { SystemInfo } from '../model';

const apiHybrisInfo = async (siteName: string) => {
    const response = await axiosForHybris.get<SystemInfo>(withParams(API.URL_HYBRIS_SYSTEM_INFO, { siteName }));

    return response.data;
};

export const useHybrisInfo = (isEnabled: boolean) => {
    const siteName = useSiteName();

    const { data } = useQuery<SystemInfo>({
        queryKey: [QUERY_KEYS.HYBRIS_INFO],
        queryFn: async () => {
            return await apiHybrisInfo(siteName);
        },
        enabled: isEnabled,
    });

    return data;
};
